<template>
  <div class="router-view">
    <router-view/>
  </div>
</template>

<script>
export default {
  methods: {
    setFavicon() {
      let faviconLink = document.getElementById('favicon');
      if (!faviconLink) {
        faviconLink = document.createElement('link');
        faviconLink.id = 'favicon';
        faviconLink.rel = 'icon';
        document.head.appendChild(faviconLink);
      }

      faviconLink.href = `${process.env.BASE_URL}img/icons/favicon.ico`;

      this.createLink('apple-touch-icon', `${process.env.BASE_URL}img/icons/apple-touch-icon.png`);
      this.createLink('icon', `${process.env.BASE_URL}img/icons/favicon-32x32.png`, '32x32');
      this.createLink('icon', `${process.env.BASE_URL}img/icons/favicon-16x16.png`, '16x16');

      this.createLink('manifest', `${process.env.BASE_URL}manifest.json`);
    },

    createLink(rel, href, sizes = null) {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (sizes) {
        link.sizes = sizes;
      }
      document.head.appendChild(link);
    }
  },
  created() {
    this.setFavicon();
  }
}
</script>

<style>
#app {
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  height: 100vh;
}
</style>